import React from "react";
import PageHeader from "../Components/PageHeader";
import ContactSection from "../Components/ContactSection";

const Contact = () => {
  return <>
  
    <PageHeader pageKey="contact" />
    <ContactSection />
  
  </>;
};

export default Contact;